<template>
    <div class="sticky left-0 top-0 mr-4">
        <Link :class="[headerLink, 'text-xl']" href="/birds"
            >{{ latestBirds?.length }} Latest Detections</Link
        >
        <p>{{ latestBirdsUpdate }}</p>
        <div class="box bg-slate-800/10 p-2">
            <ul class="flex w-full flex-wrap">
                <li
                    v-for="b in latestBirds"
                    :key="b.scientific_name + b.datetime"
                    class="bird-id mb-6 w-full overflow-hidden text-white"
                >
                    <ul class="flex w-full flex-wrap">
                        <li class="w-1/3 flex-shrink-0 overflow-hidden rounded">
                            <a
                                :href="`https://en.wikipedia.org/wiki/${b.common_name}`"
                                target="_blank"
                            >
                                <img
                                    class="aspect-square w-full border border-slate-600/40 object-cover"
                                    :src="`/storage/birds/${b.common_name}.jpg`"
                                    :title="b.common_name"
                                />
                            </a>
                        </li>
                        <li
                            class="flex w-2/3 min-w-0 flex-col justify-between pl-2"
                        >
                            <h2
                                class="truncate text-lg font-semibold leading-tight"
                            >
                                <a
                                    :href="`https://allaboutbirds.org/guide/${fixName(b.common_name)}`"
                                    target="_blank"
                                    >{{ b.common_name }}</a
                                >
                            </h2>
                            <div class="mb-1 mt-1">
                                <div
                                    class="h-1 w-full overflow-hidden rounded-full bg-amber-900"
                                >
                                    <div
                                        class="h-full rounded-full bg-amber-500/50"
                                        :style="{
                                            width: `${(b.confidence * 100).toFixed(0)}%`,
                                        }"
                                    ></div>
                                </div>
                                <p class="mt-0.5 text-sm text-slate-400">
                                    {{ (b.confidence * 100).toFixed(1) }}%
                                    confidence
                                </p>
                            </div>
                            <p class="text-base text-amber-500">
                                {{ formatDate(b.datetime, 'MMM D h:mma') }}
                            </p>
                            <p class="text-sm text-amber-700">
                                {{ b.detections }} detection<span
                                    v-if="b.detections > 1"
                                    >s</span
                                >
                                this hour
                            </p>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { Link } from '@inertiajs/vue3';
import * as DataService from '../DataService.js';
import { mapState, mapWritableState } from 'pinia';
import { useGeneralStore } from '@/utils/useGeneralStore.js';
import dayjs from 'dayjs';
import gsap from 'gsap/all';

export default {
    name: 'BirdsLatest',
    props: ['trigger', 'maxBirds'],
    components: { Link },
    watch: {
        trigger: {
            handler(n) {
                if (n) {
                    gsap.fromTo(
                        '.bird',
                        { scale: 0.8, y: 20, opacity: 0 },
                        {
                            scale: 1,
                            y: 0,
                            opacity: 1,
                            stagger: 0.05,
                            duration: 0.3,
                        },
                    );
                }
            },
            deep: true,
            immediate: true,
        },
        latestBirds: {
            handler(n) {
                // console.log(n);
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        ...mapState(useGeneralStore, ['headerLink']),
        ...mapWritableState(useGeneralStore, [
            'latestBirds',
            'latestBirdsUpdate',
        ]),
        latestBirdsShortlist() {
            return this.latestBirds.slice(0, 4);
        },
    },
    mounted() {
        this.latestBirds = this.birds ? this.birds : [];
        gsap.fromTo(
            '.bird-id',
            { scale: 0.8, y: 20, opacity: 0 },
            { scale: 1, y: 0, opacity: 1, stagger: 0.05, duration: 0.2 },
        );
    },
    methods: {
        formatDate(d, format) {
            return dayjs(d).format(format);
        },
        fixName(n) {
            n = n.replace(/ /g, '_');
            return n;
        },
        initSocket() {},
    },
};
</script>
<style lang="css">
.bird-id {
    opacity: 1;
}
</style>
>
